import $ from 'jquery';
import { debounce } from 'underscore';
import adTagBuilder from './jwplayer-ads-homepage';
import Autoplay from './jwplayer-homepage-autoplay';
import Analytics from './jwplayer-quartile-analytics';
import 'slick-carousel';

class JWPlayerInit {
    constructor() {
        this.$playlistWrapper = $('.video-module__up-next-list');
        this.$titleWrapper = $('.video-module__video-title');
        this.adTag = adTagBuilder.adUrl;
        this.player = {};
        this.options = {
            playlist: `//content.jwplatform.com/feeds/${this.determinePlaylist()}`,
            advertising: {
                client: 'googima',
                tag: this.adTag
            },
            ga: {},
            mute: true
        };
        this.slickConfig = {
            prevArrow: '',
            nextArrow: '',
            responsive: [{
                breakpoint: 99999,
                settings: "unslick"
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5.75,
                    slidesToScroll: 5,
                    infinite: false,
                    slide: '.video-module__up-next'
                }
            }, {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2.3,
                    slidesToScroll: 2,
                    infinite: false,
                    slide: '.video-module__up-next'
                }
            }]
        };
    }

    determinePlaylist() {
        var currentURL = window.location.href;
        if (/fastcompany/.test(currentURL)) {
            return 'DCmFDcAw.json';
        }
        if (/fastcodesign/.test(currentURL)) {
            return 'Siaxnx3q.json';
        }
        if (/fastcocreate/.test(currentURL)) {
            return '9b9gvmgX.json';
        }
        if (/fastcoexist/.test(currentURL)) {
            return 'ZcKpeKHw.json';
        }
    }

    initPlayer() {
        this.player.setup(this.options);

        this.player.on('ready', function () {
            var autoplay = new Autoplay(this.player);
            var analytics = new Analytics(this.player, 'videoHomepage');
            autoplay.on();
            analytics.on();
            this.updateTitle();
            this.buildPlaylistSidebar(this.player.getPlaylist());
        }.bind(this));

        this.player.on('playlistItem', function () {
            this.updateTitle();
        }.bind(this));

        this.player.on('play', function () {
            if (this.getMute() === true) {
                return this.setCurrentCaptions(1);
            }
            return this.setCurrentCaptions(0);
        });

        this.player.on('mute', function () {
            if (this.getMute() === true) {
                return this.setCurrentCaptions(1);
            }
            return this.setCurrentCaptions(0);
        });
    }

    buildPlaylistSidebar(playlist) {
        for (var i = 0; i < playlist.length; i++) {
            this.$playlistWrapper.append(
                `<li data-index=${i} class="video-module__up-next card-hover-effect">
                    <figure data-index=${i} class="video-module__up-next__article__figure">
                        <img data-index=${i} src=${playlist[i].image} />
                     </figure>
                    <span data-index=${i} class="video-module__up-next-title">${playlist[i].title}</span>
                </li>`
            );
        }

        $('.video-module__up-next').click(function (e) {
            this.player.playlistItem($(e.target).data('index'));
        }.bind(this));

        this.updateSlick();
    }

    updateTitle() {
        var video = this.player.getPlaylistItem();
        $('.video-module__up-next__article__figure--playing').removeClass('video-module__up-next__article__figure--playing');
        $(`figure[data-index=${video.index ? video.index : 0}]`).addClass('video-module__up-next__article__figure--playing');
        this.$titleWrapper.text(video.title);
    }

    updateSlick() {
        if ($(window).width() > 1023) {
            if (this.$playlistWrapper.hasClass('slick-initialized')) {
                this.$playlistWrapper.slick('unslick');
            }
            return;
        }

        if (!this.$playlistWrapper.hasClass('slick-initialized')) {
            return this.$playlistWrapper.slick(this.slickConfig);
        }
    }

    on() {
        $.getScript('//content.jwplatform.com/libraries/76APbejE.js', function () {
            this.player = jwplayer('homepage-jwplayer');
            this.initPlayer();
        }.bind(this));

        $(window).on('resize', debounce(this.updateSlick.bind(this), 300));
    }

    off() {
        this.player = {};
    }
}

export default new JWPlayerInit();
